import { defineMessages } from 'react-intl';

export default defineMessages({
    autoCompletePlaceholder: {
        id: 'anonymous.fnol.components.autoComplete.Placeholder',
        defaultMessage: 'Please start typing the address'
    }
});
